module.exports = {"1":"Mycket dålig","2":"Dålig","3":"Medel","4":"Bra","5":"Utmärkt","1.5":"Mycket dålig","2.5":"Dålig","3.5":"Medel","4.5":"Utmärkt"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/resources/localization/sv-SE/star-ratings.json
// module id = 1338
// module chunks = 0